<template>
	<div class="min-h-screen" data-allow-mismatch="children">
		<div
			class="fixed top-0 z-50 w-full"
			:class="{
				'divide-y divide-primary-light-4': isContextualHeaderVisible
			}"
		>
			<div
				class="fixed top-0 flex h-0 w-full flex-col bg-primary"
				:class="{
					'z-50 h-[60px] md:h-20 lg:z-[60]': isHeaderVisible,
					'z-50 !h-14': !isHeaderVisible && isContextualHeaderVisible
				}"
			>
				<PortalHeader
					variant="primary"
					observer
					class="h-[60px] md:h-20"
					:is-visible="isHeaderVisible"
					@nav-option-being-shown="isMenuBeingShown = true"
					@nav-option-closed="isMenuBeingShown = false"
				/>
			</div>
			<div
				class="fixed flex w-full flex-col bg-primary"
				:class="[
					isHeaderVisible ? 'top-[60px] md:top-[80px]' : 'top-0',
					isMenuBeingShown ? 'z-40 lg:z-50' : 'z-50'
				]"
			>
				<ContextualHeader :is-visible="isContextualHeaderVisible" />
			</div>
		</div>

		<main class="box-border size-full pt-[60px] md:pt-20">
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSection :is-visible="isContextualHeaderVisible" />
		</Container>
		<Container class="bg-primary !py-0">
			<PortalFooter />
		</Container>
	</div>
</template>

<script setup lang="ts">
import { isMobileDevice } from '~~/utils';

const isHeaderVisible = ref<boolean>(true);
const isMenuBeingShown = ref<boolean>(false);

const isContextualHeaderVisible = ref<boolean>(false);
provide('isContextualHeaderVisible', isContextualHeaderVisible);
</script>
